webpackJsonp([3871729127950],{

/***/ 811:
/***/ (function(module, exports) {

	module.exports = {"data":{"contributionsJson":{"name":"geflügel","www_url":"http://www.r23.ch","thema":"istanbul","issue_month":"January","issue_year":2006,"issue_date":200601,"artist":"linda","location":"Switzerland","email":"ruth@i-love-u.ch","id":"contribution_172","media_type":"still_image","position_in_section":2,"media_uri":"media/2006/January/still_image/geflügel01.jpg","media_th_uri":"media/2006/January/still_image/tn_geflügel01.jpg","still_image_count":3,"moving_image_count":7,"textz_count":3,"soundz_count":0}},"pathContext":{"id":"contribution_172"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200601-still-image-2-d8cdbbefdecb77b7942a.js